var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.numbers),function(number,index){return _c('img',{key:index,attrs:{"src":_vm.img(number),"name":"slide"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }